import api from '@/api'
import { sortBy } from 'lodash'

export default {
  namespaced: true,

  state: () => ({
    data: [],
    selected: null
  }),

  actions: {
    get: async function (ctx, params) {
      const response = await api.get(`/v1/restaurants/${ctx.rootState.currentRestaurant.data._id}/areas`, params)

      ctx.commit('set', response.data)
    }
  },

  mutations: {
    setArea: function (state, area) {
      state.selected = area
    },

    set: function (state, areas) {
      const data = areas.map(area => ({ name: area.name, _id: area._id, uuid: area._id, id: area._id }))
      state.data = sortBy(data, 'name')
    },

    add: function (state, area) {
      let areas = [...state.data]

      areas.push(area)

      areas = areas.filter(function (value, index, array) {
        return array.indexOf(value) === index
      })

      state.data = sortBy(areas, 'name')
    },

    update: function (state, area) {
      const areas = [...state.data]

      const areaIndex = areas.findIndex(item => item._id === area._id)

      if (areaIndex >= 0) {
        areas[areaIndex] = area
      } else {
        areas.push(area)
      }

      state.data = sortBy(areas, 'name')
    },

    delete: function (state, area) {
      const areas = [...state.data]

      const areaIndex = areas.findIndex(r => r._id === area._id)

      if (areaIndex >= 0) {
        areas.splice(areaIndex, 1)
      }

      state.data = areas
    },

    reset: function (state) {
      state.data = []
    }
  }
}
